import { render, staticRenderFns } from "./TaskStatusBadge.vue?vue&type=template&id=b01c27fa&scoped=true&"
import script from "./TaskStatusBadge.vue?vue&type=script&lang=js&"
export * from "./TaskStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./TaskStatusBadge.vue?vue&type=style&index=0&id=b01c27fa&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01c27fa",
  null
  
)

export default component.exports